import React, { useState, useEffect, useCallback } from 'react';
import { Button, Spinner, Alert, Form, Row, Col, Modal, Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft, FaVideo, FaFileAlt, FaUserAlt, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa'; 
import { getAppliedRoleListForDrCr, fetchUserJogetProfileUUDIApi, saveApplicationReview,modifyAdminCommentApi,incrementKnowMoreApi  } from '../../services/api'; 
import MetaTags from '../../components/MetaTags'; 
import './ManageApplicationsPage.css'; // The new/updated CSS file
import axios from 'axios';
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2"; 
const BASE_URL = process.env.REACT_APP_API_URL.replace("/api", "");


// --- HELPERS (Copied from your original code) ---
const calculateAge = (dobString) => {
    if (!dobString) return '---';
    const [month, day, year] = dobString.split('/').map(Number);
    const birthDate = new Date(year, month - 1, day); 
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
};

const ManageApplicationDetails = () => {
    const { id: roleApplicationId } = useParams(); 
    const navigate = useNavigate();

    const [selectedApp, setSelectedApp] = useState(null);
    const [talentProfile, setTalentProfile] = useState(null);
    const [loadingApp, setLoadingApp] = useState(true);
    const [loadingProfile, setLoadingProfile] = useState(false);
    const [error, setError] = useState('');
    const [currentStep, setCurrentStep] = useState(1);
    const [decision, setDecision] = useState(''); // This is the 'result'
    const [candidateProfile, setCandidateProfile] = useState('');
    const [showProfilePicModal, setShowProfilePicModal] = useState(false);
    
    const [videoPlayedToEnd, setVideoPlayedToEnd] = useState(false);
    const [reviewText, setReviewText] = useState('');
    const [ratingStar, setRatingStar] = useState(0); // New state for star rating
    const [hoverRating, setHoverRating] = useState(0); // For hover effect on stars
    const [reviewSaved, setReviewSaved] = useState(false); 
    const [saveReviewLoading, setSaveReviewLoading] = useState(false);
    const location = useLocation();
    const adminToken = localStorage.getItem("adminToken");
    const isAdmin = !!adminToken;
    const [adminReviewText, setAdminReviewText] = useState('');

    const c_R_Status = selectedApp?.c_result;
    // const hasNewVideo = selectedApp?.video_uploaded === true;
//     const lastReviewTime = selectedApp?.updated_at;
// const lastVideoTime = selectedApp?.video_uploaded_on;

// const hasNewVideo =
//   lastVideoTime && lastReviewTime && new Date(lastVideoTime) > new Date(lastReviewTime);
const hasNewVideo = selectedApp?.video_uploaded_on !== null;
    const isResubmit = c_R_Status === "RESUBMIT";

    const canReviewAgain = isResubmit && hasNewVideo;
    // const isCDLocked = reviewSaved && !hasNewVideo && !isAdmin;
//     const isCDLocked =
//   selectedApp?.c_ratingStar > 0 &&
//   selectedApp?.c_isRated === "Yes" &&
//   !hasNewVideo &&
//   !isAdmin;


const isCDLocked =
  selectedApp?.c_ratingStar > 0 && !isAdmin;

// const isCDLocked =
//   selectedApp?.c_ratingStar > 0 &&
//   !isAdmin &&
//   !selectedApp?.video_uploaded;

    const handleBack = () => {
        if (location.pathname.includes('/admin')) {
            navigate('/admin/audition-list'); 
        } else {
            navigate('/dashboard/manage-applications');
        }
    };

    const loadApplicationAndProfile = useCallback(async () => {
        setLoadingApp(true);
        setError('');
        setVideoPlayedToEnd(false);
        setReviewText('');
        setRatingStar(0); // Reset rating
        setReviewSaved(false);
        setDecision(''); // Reset decision

        try {
            const response = await getAppliedRoleListForDrCr();
            const rawData = response.data.data || [];
            
            const foundApp = rawData.find(item => item.roleApplicationId === roleApplicationId);
            console.log("FOUND APP:", foundApp);

            if (!foundApp) {
                setError('Application not found.');
                setLoadingApp(false);
                return;
            }
            const candidateId = foundApp.candidateJogetId || foundApp.c_userId || foundApp.userId;
            if (!candidateId) {
                console.error("Candidate ID missing in app data:", foundApp);
                setError('Could not identify the candidate profile ID.');
                setLoadingApp(false);
                return;
            }
            const videoUrl = foundApp.c_videoUrl || null;
            const initialReview = foundApp.c_review || '';
            const c_R_Status = foundApp.c_result || 'Pending';
            const c_V_Status = foundApp.c_approval_status || 'Pending';
            const c_audition_type = foundApp.bookingType || 'N/A';
            const initialRating = parseInt(foundApp.c_ratingStar || '0', 10); // Get initial rating

            let c_B_Month = '202401'; 
            let c_S_Date = '01/01/2024';

            try {
                const roleSchedules = JSON.parse(foundApp?.roleScheduleJson||'[]');
                if (Array.isArray(roleSchedules) && roleSchedules.length > 0 && roleSchedules[0].c_startDate) {
                    const startDate = new Date(roleSchedules[0].c_startDate);
                    if (!isNaN(startDate)) {
                        c_B_Month = `${startDate.getFullYear()}${(startDate.getMonth() + 1).toString().padStart(2, '0')}`;
                        c_S_Date = `${startDate.getDate().toString().padStart(2, '0')}/${(startDate.getMonth() + 1).toString().padStart(2, '0')}/${startDate.getFullYear()}`;
                    }
                }
            } catch (e) { console.error("Error parsing roleScheduleJson:", e); }

            const transformedApp = {
                ...foundApp,
                talent_name: foundApp.candidateName || '',
                c_role_name: foundApp.c_roleName,
                c_project_name: foundApp.projectName,
                talent_id: foundApp.appliedByUser,
                c_R_Status: c_R_Status,
                c_B_Month: c_B_Month,
                c_S_Date: c_S_Date,
                c_V_Status: c_V_Status,
                c_audition_type: c_audition_type,
                c_roleScene: foundApp.c_roleScene || 'No scene details provided.',
                c_roleScript: foundApp.c_roleScript || 'No audition script provided.',
                c_videoUrl: videoUrl,
                c_initialReview: initialReview,
                c_ratingStar: initialRating, // Store initial rating
                c_result: c_R_Status, // Store initial result
                c_isRated: (foundApp.c_isRated === 'Yes') ? 'Yes' : "No"   
            };

            setSelectedApp(transformedApp);
            console.log("🔥 APP DATA:", transformedApp);
            setReviewText(initialReview);
            setRatingStar(initialRating); // Set initial rating
            setDecision(c_R_Status); // Set initial decision
            setAdminReviewText(foundApp.modified_by_admin || '');
            
            // Check if review was already saved
            if (
                initialReview.trim() !== '' &&
                initialRating !== 0 &&
                (c_R_Status === "SELECTED" || c_R_Status === "REJECTED" || (isResubmit && !hasNewVideo))
            ) {
                setReviewSaved(true);  // 🔒 lock
            } else {
                setReviewSaved(false); // 🔓 unlock
            }
            // if (initialReview.trim() !== '' && initialRating !== 0 && (c_R_Status === "SELECTED" || c_R_Status === "REJECTED" || c_R_Status === "RESUBMIT")) {
            //     setReviewSaved(true);
            // }

            setLoadingProfile(true);
            try {
                const res = await fetchUserJogetProfileUUDIApi(candidateId);
                setCandidateProfile(res.data.profileImageUrl);
                // setTalentProfile(res.data.jogetData);
                setTalentProfile({
                    ...res.data.jogetData,
                    knowMoreCount: res.data.knowMoreCount
                });
            } catch (e) {
                console.error("Profile load error:", e);
            } finally {
                setLoadingProfile(false);
            }
        } catch (err) {
            setError('Failed to load application details.');
        } finally {
            setLoadingApp(false);
        }
    }, [roleApplicationId]);

    useEffect(() => { 
        if (roleApplicationId) { 
            loadApplicationAndProfile(); 
        }
    }, [roleApplicationId, loadApplicationAndProfile]);

    const handleSaveReview = async () => {
        if (!reviewText.trim()) {
            return setError("Review cannot be empty.");
        }
        if (!decision) {
            return setError("Please select a result (decision).");
        }
        if (ratingStar === 0) {
            return setError("Please provide a star rating.");
        }

        setSaveReviewLoading(true);
        setError('');

        try {
            const payload = {                
                roleId: selectedApp.c_roleId, 
                userId: selectedApp.appliedByUser, 
                addedBy: selectedApp.drcrUserId, 
                applicationId: roleApplicationId,                
                review: reviewText,
                ratingStar: ratingStar.toString(),
                result: decision,
                isAdmin: isAdmin 
            };

            const res = await saveApplicationReview(payload);

            if (res.data.success) {
                // alert('Review, Rating, and Status saved successfully!');
                Swal.fire({
                    icon: "success",
                    title: "Success!",
                    text: "Review, Rating, and Status saved successfully!",
                    confirmButtonText: "OK"
                });
                setReviewSaved(true);
                // After saving, ensure the component reflects the saved state without full reload
                setSelectedApp(prev => ({
                    ...prev,
                    c_initialReview: reviewText,
                    c_ratingStar: ratingStar,
                    c_result: decision,
                    c_isRated: 'Yes'
                }));
            } else {
                setError(res.data.message || 'Failed to save review.');
            }

        } catch (err) {
            console.error('Error saving review:', err.response?.data || err.message);
            setError(err.response?.data?.message || 'Failed to save review.');
        } finally {
            setSaveReviewLoading(false);
        }
    };

    const handleAdminModifyComment = async () => {
        if (!adminReviewText.trim()) {
            // return setError("Admin comment cannot be empty");
            return Swal.fire({
                icon: "warning",
                title: "Validation Error",
                text: "Admin comment cannot be empty",
                background: "#111111",
                color: "#ffffff",
                confirmButtonColor: "#8B0000"
            });
        }

        try {
            const payload = {
                applicationId: roleApplicationId,
                modifiedComment: adminReviewText
            };

            console.log("ADMIN PAYLOAD:", payload);

            const res = await modifyAdminCommentApi(payload);

            if (res.data.success) {
                // alert("Admin comment updated");
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Admin comment updated successfully",
                    background: "#111111",
                    color: "#ffffff",
                    confirmButtonColor: "#8B0000",
                    confirmButtonText: "OK"
                });

                setSelectedApp(prev => ({
                    ...prev,
                    modified_by_admin: adminReviewText
                }));
            }

        } catch (err) {
            // setError("Failed to update admin comment");
             Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to update admin comment",
                background: "#111111",
                color: "#ffffff",
                confirmButtonColor: "#8B0000"
            });
        }
    };

    if (loadingApp) return <div className="text-center p-5"><Spinner className="text-white" animation="border" variant="danger" /></div>;
    if (error && !selectedApp) return <Alert variant="danger" className="m-3">{error}</Alert>;
    if (!selectedApp) return <Alert variant="info" className="m-3">Application details could not be loaded.</Alert>;

    console.log("🔥 APP DATA:", selectedApp);

    // Derived state for review status and display
    const isFinalReviewed = selectedApp?.c_isRated === "Yes" && (selectedApp?.c_result === "SELECTED" || selectedApp?.c_result === "REJECTED"); // Only if rated and decision made
    console.log({
  rating: selectedApp?.c_ratingStar,
  isRated: selectedApp?.c_isRated,
  hasNewVideo,
  isCDLocked
});
    
    const steps = ['Application', 'Script', 'Media']; 
    console.log("talentProfile App Data:", talentProfile);
    const tp = talentProfile || {};
    const talentAge = calculateAge(tp.dateOfBirth);

    const getStatusBadge = (status) => {
        switch (status) {
            case "SELECTED": return (<span className="status-badge status-selected">✓ SELECTED</span>);
            case "REJECTED": return (<span className="status-badge status-rejected">✕ REJECTED</span>);
            case "RESUBMIT": return (<span className="status-badge status-resubmit">↻ RESUBMIT</span>);
            default: return (<span className="status-badge status-pending">⏳ PENDING</span>);
        }
    };

    const handleKnowMore = async () => {
           console.log("selectedApp =", selectedApp);
    console.log("talent_id =", selectedApp?.talent_id);
    console.log("candidateJogetId =", selectedApp?.candidateJogetId);
    console.log("userId =", selectedApp?.userId);
    console.log("c_userId =", selectedApp?.c_userId);
    try {
        await incrementKnowMoreApi(
            selectedApp.talent_id
        );
        // navigate(
        //     `/dashboard/profile/${selectedApp.talent_id}`
        // );
        if (localStorage.getItem("adminToken")) {

             navigate(`/admin/candidate-profile/${selectedApp.talent_id}?knowMore=true`);

        } else {

            navigate(
                `/dashboard/profile/${selectedApp.talent_id}?knowMore=true`
            );

        }

    } catch (err) {
        console.error(err);
    }
};

    return (
        <div className="review-wizard-overlay animate-fade-in p-lg-5 p-3">
            <MetaTags title="Application details - BookMyAudition" />
            <div className="application-header d-flex justify-content-between align-items-center mb-4"> 
                <h5 className="fw-bold pb-2 mb-0 manage-application">Application Details</h5> 
                {/* <Button variant="outline-light" size="sm" onClick={() => navigate('/dashboard/manage-applications')}><FaArrowLeft className="me-2" /> Back</Button> */}
                <Button variant="outline-light" size="sm" onClick={handleBack}><FaArrowLeft className="me-2" /> Back</Button>

            </div>

            <Row className="g-4">
                {/* LEFT SIDE: TALENT SIDEBAR (4-COLUMN GRID) */}
                <Col lg={4}>
                    <div className="talent-sidebar-card custom-card">
                        <div className="sidebar-red-header">
                            <div 
                                className="talent-avatar-box" 
                                onClick={() => candidateProfile && setShowProfilePicModal(true)}
                                style={{ cursor: candidateProfile ? 'pointer' : 'default' }}
                            >
                                {candidateProfile ? (
                                    <img src={candidateProfile} alt="Candidate Profile" className="profile-image-thumbnail" />
                                ) : (
                                    <FaUserAlt size={35} />
                                )}
                            </div>
                            <h5 className="mt-3 mb-0 text-uppercase">{selectedApp.talent_name}</h5>
                            <small className="opacity-75">Candidate Profile</small>
                            <div className="mt-2">{getStatusBadge(selectedApp.c_result)}</div> {/* Display current status here */}
                        </div>
                        <div className="sidebar-body p-3">
                            {loadingProfile ? (
                                <div className="text-center py-5"><Spinner className="text-white" size="sm" variant="danger" /></div>
                            ) : (
                                <>
                                    <h6 className="sidebar-section-title">Candidate Attributes</h6>
                                    <div className="meta-grid-4-col">
                                        <div className="meta-cell"><label>Age</label><span>{talentAge}</span></div>
                                        <div className="meta-cell"><label>Gender</label><span>{tp.gender || '---'}</span></div>
                                        <div className="meta-cell"><label>Height</label><span>{tp.height || '---'} cm</span></div>
                                        <div className="meta-cell"><label>Weight</label><span>{tp.weight || '---'} kg</span></div>
                                        <div className="meta-cell"><label>Skin</label><span>{tp.skinType || '---'}</span></div>
                                        <div className="meta-cell"><label>Eyes</label><span>{tp.eyeColour || '---'}</span></div>
                                        <div className="meta-cell"><label>Hair Type</label><span>{tp.hairType || '---'}</span></div>
                                        <div className="meta-cell"><label>Hair Color</label><span>{tp.hairColor || '---'}</span></div>
                                        <div className="meta-cell"><label>Body</label><span>{tp.bodyType || '---'}</span></div>
                                        <div className="meta-cell"><label>Nationality</label><span>{tp.nationality || '---'}</span></div>
                                        <div className="meta-cell"><label>Education</label><span>{tp.educationLevel || '---'}</span></div>
                                        <div className="meta-cell"><label>Currency</label><span>{tp.preferredCurrency || '---'}</span></div>
                                    </div>

                                    <h6 className="sidebar-section-title mt-4">Biography</h6>
                                    <p className="small text-white-50">{tp.aboutYourself || "No description provided."}</p>

                                    {/* <div className="mt-3 text-center"> <label className="text-muted"> Know More Viewed </label>
                                            <h5 className="text-danger fw-bold">{talentProfile?.knowMoreCount || 0}</h5>
                                    </div> */}
                                    <Button variant="outline-danger" size="sm" className="w-100 mt-3 rounded-pill" onClick={handleKnowMore}> KNOW MORE</Button>
                                    
                                    {/* <Button variant="outline-danger" size="sm" className="w-100 mt-3 rounded-pill" 
                                    onClick={() => navigate(`/dashboard/profile/${selectedApp.talent_id}`)}
                                    >KNOW MORE</Button> */}
                                    
                                </>
                            )}
                        </div>
                    </div>
                </Col>

                {/* RIGHT SIDE: WIZARD CONTENT */}
                <Col lg={8}>
                    <div className="wizard-review-container custom-card">
                        <div className="wizard-stepper-row">
                            {steps.map((step, i) => (
                                <div key={i} className={`step-item-custom ${currentStep >= i + 1 ? 'active' : ''}`} onClick={() => setCurrentStep(i + 1)}>
                                    <div className="step-circle-custom">{i + 1}</div>
                                    <div className="step-label-custom">{step}</div>
                                </div>
                            ))}
                        </div>
                        <div className="red-strip-bar">
                            <span>{steps[currentStep-1]}</span>
                            <span>Step {currentStep} of {steps.length}</span>
                        </div>
                        <div className="wizard-body-content p-4">
                            {/* --- STEP 1: APPLICATION DETAILS --- */}
                            {currentStep === 1 && (
                                <div className="animate-fade-in">
                                    <h6 className="form-section-title text-danger fw-bold text-uppercase mb-3">Application Details</h6>
                                    <div className="meta-info-dark-card p-3 rounded">
                                        <Row className="g-3">
                                            <Col xs={12} md={6}><label className="lbl">Project</label><div className="val">{selectedApp.c_project_name}</div></Col>
                                            <Col xs={12} md={6}><label className="lbl">Role</label><div className="val">{selectedApp.c_role_name}</div></Col>
                                            <Col xs={12} md={6}><label className="lbl">Audition Month</label><div className="val">{selectedApp.c_B_Month}</div></Col>
                                            <Col xs={12} md={6}><label className="lbl">Audition Mode</label><div className="val">{selectedApp.c_audition_type}</div></Col>
                                            <Col xs={12} md={6}><label className="lbl">Schedule Date</label><div className="val">{selectedApp.c_S_Date}</div></Col>
                                            <Col xs={12} md={6}><label className="lbl">Verification Status</label><div className="val">{selectedApp.c_V_Status}</div></Col>
                                            {
                                                selectedApp?.bookingType === "ONLINE_MEETING" &&
                                                selectedApp?.meetingLink && (
                                                    <Col xs={12}>
                                                        <Button
                                                            variant="success"
                                                            href={selectedApp.meetingLink}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="w-100 mt-3"
                                                        >
                                                            🎥 Join Meeting
                                                        </Button>

                                                        {
                                                            selectedApp?.meetingStart && (
                                                                <div className="text-muted mt-2">
                                                                    Meeting Time :
                                                                    {" "}
                                                                    {new Date(
                                                                        selectedApp.meetingStart
                                                                    ).toLocaleString()}
                                                                </div>
                                                            )
                                                        }
                                                    </Col>
                                                )
                                            }
                                        </Row>
                                    </div>
                                </div>
                            )}

                            {/* --- STEP 2: SCENE & SCRIPT --- */}
                            {currentStep === 2 && (
                                <div className="animate-fade-in">
                                    <Row className="g-3">
                                        <Col xs={12} md={6}>
                                            <h6 className="form-section-title text-danger small fw-bold text-uppercase mb-2"><FaFileAlt className="me-2"/>Scene Details</h6>
                                            <div 
                                                className="script-view-box p-3 rounded" 
                                                dangerouslySetInnerHTML={{ __html: selectedApp.c_roleScene || 'N/A' }} 
                                            />
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <h6 className="form-section-title text-danger small fw-bold text-uppercase mb-2"><FaFileAlt className="me-2"/>Audition Script</h6>
                                            <div 
                                                className="script-view-box p-3 rounded" 
                                                dangerouslySetInnerHTML={{ __html: selectedApp.c_roleScript || 'N/A' }} 
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            )}

                            {/* --- STEP 3: MEDIA & REVIEW --- */}
                            {currentStep === 3 && (
                                <div className="animate-fade-in text-center py-2">
                                    <h6 className="form-section-title text-danger fw-bold text-uppercase mb-4">Candidate Performance</h6>
                                    
                                    {/* VIDEO PLAYER */}
                                    {selectedApp.c_audition_type === "VIDEO_UPLOAD" && selectedApp.c_videoUrl && (
                                        <div className="video-player-container">
                                            <div className="video-player-area">
                                                <video
                                                    controls
                                                    width="100%"
                                                    height="auto"
                                                    onEnded={() => setVideoPlayedToEnd(true)}
                                                    // src={`https://bma.on.joget.cloud/jw/web/client/app/bookmyaudition/form/download/roleApplication/${roleApplicationId}/${selectedApp?.c_videoUrl}`}
                                                    // type="video/mp4"
                                                    src={selectedApp?.c_videoUrl}
                                                >
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                        </div>
                                    )}

                                    {/* REVIEW SECTION */}
                                    {/* {(selectedApp.c_audition_type === "SLOT_BOOKING" || videoPlayedToEnd) */}
                                    {(selectedApp.c_audition_type === "SLOT_BOOKING" || selectedApp.c_audition_type === "ONLINE_MEETING" ||
                                         selectedApp.c_audition_type === "FACE_TO_FACE"  || videoPlayedToEnd || isAdmin)
                                     && (
                                        <div className="review-box mt-2 p-2 animate-fade-in">
                                            {isFinalReviewed ? (
                                                <div className="premium-review-card">
                                                    <div className={`premium-status-header ${selectedApp.c_result?.toLowerCase()}`}>
                                                        <div className="status-icon">
                                                            {selectedApp.c_result === "SELECTED" ? "✓" : "✕"}
                                                        </div>
                                                        <div>
                                                            <div className="status-title">
                                                                {selectedApp.c_result === "SELECTED" ? "Candidate Selected" : "Candidate Rejected"}
                                                            </div>
                                                            <div className="status-sub">
                                                                Final decision has been submitted
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="premium-rating-section">
                                                        <div className="rating-number">
                                                            {selectedApp.c_ratingStar}.0
                                                        </div>
                                                        <div className="rating-stars">
                                                            {[...Array(5)].map((_, index) => (
                                                                <FaStar
                                                                    key={index}
                                                                    size={28}
                                                                    color={index < selectedApp.c_ratingStar ? "#f5c518" : "#2c2c2c"}
                                                                />
                                                            ))}
                                                        </div>
                                                        <div className="rating-label">
                                                            Overall Performance Score
                                                        </div>
                                                    </div>

                                                    <div className="premium-review-text">
                                                        <div className="review-title">Comments:</div>
                                                        {/* <p>
                                                            {selectedApp.c_initialReview || "No comments provided."}
                                                        </p> */}
                                                        <p>
                                                        {selectedApp.admin_review 
                                                            ? selectedApp.admin_review 
                                                            : selectedApp.c_initialReview || "No comments provided."}
                                                        </p>
                                                        
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <h6 className="text-white fw-bold mb-3">
                                                        Add Your Review & Set Status
                                                    </h6>

                                                    {/* STAR RATING */}
                                                    <div className="star-rating mb-3">
                                                        {[...Array(5)].map((_, index) => {
                                                            const ratingValue = index + 1;
                                                            return (
                                                                <label key={index}>
                                                                    <input
                                                                        type="radio"
                                                                        name="rating"
                                                                        value={ratingValue}
                                                                        onClick={() => setRatingStar(ratingValue)}
                                                                        // disabled={reviewSaved}
                                                                        disabled={isCDLocked}
                                                                    />
                                                                    <FaStar
                                                                        size={30}
                                                                        color={
                                                                            ratingValue <= (hoverRating || ratingStar)
                                                                                ? "#ffc107"
                                                                                : "#e4e5e9"
                                                                        }
                                                                        onMouseEnter={() => setHoverRating(ratingValue)}
                                                                        onMouseLeave={() => setHoverRating(0)}
                                                                        style={{ cursor: reviewSaved ? "default" : "pointer" }}
                                                                    />
                                                                </label>
                                                            );
                                                        })}
                                                    </div>

                                                    {/* REVIEW TEXT */}
                                                    <Form.Group className="mb-3">
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={4}
                                                            placeholder="Enter your review here..."
                                                            value={reviewText}
                                                            onChange={(e) => setReviewText(e.target.value)}
                                                                disabled={isCDLocked}
                                                            // disabled={reviewSaved}
                                                        />
                                                    </Form.Group>

                                                    {isAdmin && (
                                                        <Form.Group className="mb-3">
                                                            <Form.Label className="text-warning fw-bold">
                                                            Admin Modify Comment
                                                            </Form.Label>
                                                            <Form.Control
                                                            as="textarea"
                                                            rows={3}
                                                            placeholder="Admin can modify comment..."
                                                            value={adminReviewText}
                                                            onChange={(e) => setAdminReviewText(e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    )}

                                                    {/* STATUS DROPDOWN */}
                                                    <Form.Group className="mb-4">
                                                        <Form.Select
                                                            value={decision}
                                                            onChange={(e) => setDecision(e.target.value)}
                                                            disabled={isCDLocked}
                                                            // disabled={reviewSaved}
                                                        >
                                                            <option value="">-- Choose Status --</option>
                                                            <option value="SELECTED">Selected</option>
                                                            {selectedApp.c_audition_type === "VIDEO_UPLOAD" && (<option value="RESUBMIT">Resubmit</option>)}
                                                            <option value="REJECTED">Rejected</option>
                                                        </Form.Select>
                                                    </Form.Group>

                                                    {/* SAVE BUTTON */}
                                                    <Button
                                                        variant="danger"
                                                        className="w-100 py-2 fw-bold"
                                                        onClick={handleSaveReview}
                                                        // disabled={reviewSaved || !reviewText.trim() || !decision || ratingStar === 0 || saveReviewLoading}
                                                      disabled={
                                                        isAdmin ||   
                                                    (isCDLocked) ||
                                                    !reviewText.trim() ||
                                                    !decision ||
                                                    ratingStar === 0 ||
                                                    saveReviewLoading
                                                    }
                                                    >
                                                        {saveReviewLoading ? (
                                                            <Spinner className="text-white" animation="border" size="sm" />
                                                        ) : reviewSaved ? (
                                                            "Review Saved"
                                                        ) : (
                                                            "Save Review"
                                                        )}
                                                    </Button>
                                                    {isAdmin && (
                                                        <Button
                                                            variant="warning"
                                                            className="w-100 mt-2 fw-bold"
                                                            onClick={handleAdminModifyComment}
                                                        >
                                                            Modify Comment (Admin)
                                                        </Button>
                                                    )}

                                                    {reviewSaved && (
                                                        <Alert variant="success" className="mt-2">
                                                            Review saved successfully!
                                                        </Alert>
                                                    )}
                                                    {error && (
                                                        <Alert variant="danger" className="mt-2">
                                                            {error}
                                                        </Alert>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="wizard-footer d-flex justify-content-between p-3 border-top border-white-10">
                            <Button variant="outline-light" size="sm" disabled={currentStep === 1} onClick={() => setCurrentStep(prev => prev - 1)}><FaChevronLeft className="me-2" /> PREVIOUS</Button>
                            {currentStep < steps.length && <Button variant="danger" size="sm" onClick={() => setCurrentStep(prev => prev + 1)}>NEXT <FaChevronRight className="ms-2" /></Button>}
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Profile Picture Modal */}
            <Modal show={showProfilePicModal} onHide={() => setShowProfilePicModal(false)} centered size="lg">
                <Modal.Header closeButton className="bg-dark text-white border-bottom-0">
                    <Modal.Title className="text-white">Candidate Profile Picture</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark text-center p-0">
                    {candidateProfile && (
                        <img src={candidateProfile} alt="Candidate Profile Full" style={{ maxWidth: '100%', height: 'auto' }} />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ManageApplicationDetails;